/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./ViewFOSIDDetails.module.css";
import Close from "../../Components/Icons/Close";

import { getFOSKYCDocuments, getDeletedFosData } from "../../Services/ChannelPartner";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));
export default function ViewFOSIDDetails({
  open,
  data,
  handleClose,
  showError,
}) {
  const classes = useStyles();
  const [panCardDetails, setPanCardDetails] = useState("");
  const [aadharDetails, setAadharDetails] = useState("");
  useEffect(() => {
    if (data.isDeleted) {
      // KycDocuments are hard-deleted once a FOS is suspended;
      // pull the archived snapshot from DeletedCpFos instead.
      getDeletedFosData(data.fosId).then((archived) => {
        const kycRes = archived?.kycDocuments || [];
        setPanCardDetails(kycRes.find((el) => el.docType === "PanCard"));
        setAadharDetails(kycRes.find((el) => el.docType === "AadharCard"));
      }).catch((err) => {
        showError("Error While loading archived FOS data.Please try again later!")
        console.log("Error while loading archived FOS data", err);
      });
      return;
    }
    getFOSKYCDocuments(data.fosId).then((kycRes) => {
      setPanCardDetails(
        kycRes.find((el) => {
          if (el.docType === "PanCard") {
            return el;
          }
        })
      );
      setAadharDetails(
        kycRes.find((el) => {
          if (el.docType === "AadharCard") {
            return el;
          }
        })
      );
    }).catch((err) => {
      showError("Error While loading Documents.Please try again later!")
      console.log("Error while loading Documents", err);
    })
  }, []);
  function closeModal() {
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.header}>
            <div className={cssClasses.headerTitle}>
              FOS Details{" "}
            </div>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.5rem"} height={"1.5rem"} />
            </span>
          </div>
          <div className={cssClasses.content}>
            <div className={cssClasses.leftContent}>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.title}>{data.name}</div>
                <div className={cssClasses.email}>
                  {data.email} | {data.contactNumber}
                </div>
              </div>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockTitle}>General Details</div>
                {[0, 0].map((el, index) => {
                  return (
                    <>
                      <div className={cssClasses.keyValue}>
                        <div className={cssClasses.key}>
                          {index === 0 ? "PAN Number" : 'Aadhar Number'}:
                        </div>
                        <div className={cssClasses.value}>{index === 0 ? panCardDetails?.docNumber ?? 'NA' : aadharDetails?.docNumber ?? 'NA'}</div>
                      </div>
                      <div className={cssClasses.keyValue}>
                        <div className={cssClasses.key}>
                          {index === 0 ? "PAN Name" : 'Aadhar Name'}:
                        </div>
                        <div
                          className={cssClasses.value}
                          style={{
                            color: "#1570ef",
                          }}
                        >
                          {index === 0 ? panCardDetails?.docHolderName ?? 'NA' : (aadharDetails?.docHolderName && aadharDetails?.docHolderName !== "") ? aadharDetails?.docHolderName : 'NA'}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <div className={cssClasses.rightContent}>
              <div className={cssClasses.keyValue}>
                <div className={cssClasses.key}>CP :</div>
                <div className={cssClasses.value}>{data?.cpName}</div>
              </div>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockTitle}>Bank Details</div>

                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Account Holder Name :</div>
                  <div className={cssClasses.value}>
                    {data.bankAccountHolderName ? data.bankAccountHolderName : "NA"}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Account Number :</div>
                  <div className={cssClasses.value}>
                    {data.bankAccountNumber ? data.bankAccountNumber : "NA"}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>IFSC Code :</div>
                  <div className={cssClasses.value}>
                    {data.bankIFSCCode ? data.bankIFSCCode : "NA"}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Branch Name :</div>
                  <div className={cssClasses.value}>
                    {data.bankBranchName ? data.bankBranchName : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
